import React from "react";
import { getModalitiesAsync, patchModalitiesAsync } from "../../../../app/patientSlice";
import ConfirmationModal from "../../../secondary/ConfirmationModal/ConfirmationModal";
import { MultiSelectSectionEditMode } from "./MultiSelectSectionEditMode";
import { MultiSelectSectionViewMode } from "./MultiSelectSectionViewMode";
import { handleListViewMenuChangeMove } from "../../../../utils/deeHelper";
import { useSectionForm } from "./hooks/useSectionForm";

const CONFIRMATION_MESSAGE = "All progress in this section will be lost. Are you sure want to cancel?";

const dataSelector = (state) => state.patient.modalities;
const listSelector = (state) => state.patient.modalitiesListoptions;

const hasDataFn = (resp, dataKey) => Array.isArray(resp?.[dataKey]) && resp[dataKey].length > 0;

const makePayloadBuilder = (getListViewMenuData) => (_, base) => ({
  ...base,
  modalities: getListViewMenuData(),
});

const processSelection = (e, setData) => handleListViewMenuChangeMove(e, setData);

export const Modalities = ({ interventionId, assessmentDetails }) => {
  const hook = useSectionForm({
    interventionId,
    dataSelector,
    listSelector,
    fetchAction: getModalitiesAsync,
    patchAction: patchModalitiesAsync,
    optionType: "modalities",
    dataKey: "modalities",
    hasDataFn,
    buildPayload: makePayloadBuilder(() => hook.listViewMenuData),
    processSelection,
  });

  return (
    <div>
      {hook.confirmationModal && (
        <ConfirmationModal message={CONFIRMATION_MESSAGE} onConfirm={hook.yesConfirmationModalClick} onClose={hook.confirmationClose} />
      )}

      {hook.editable ? (
        <MultiSelectSectionEditMode
          label="Modalities:"
          fieldId="modalities"
          assessmentDetails={assessmentDetails}
          setFormChangesConfirm={hook.setFormChangesConfirm}
          handleSubmit={hook.handleSubmit}
          doSubmit={hook.doSubmit}
          listResp={hook.listResp}
          sectionData={hook.sectionData}
          listViewRef={hook.listViewRef}
          register={hook.register}
          onSelectChange={hook.handleListViewMenuChange}
          onCancelClick={hook.handleCancelClick}
          hideButtons={hook.hideButtons}
        />
      ) : (
        <MultiSelectSectionViewMode
          label="Modalities:"
          sectionData={hook.sectionData}
          listResp={hook.listResp}
          assessmentDetails={assessmentDetails}
          hideButtons={hook.hideButtons}
          onEdit={hook.editMode}
        />
      )}
    </div>
  );
};
